import React, { memo } from 'react';
import styled from 'styled-components';
import useSyndicateTimezoneLabel from '../../../../../utils/hooks/useSyndicateTimezoneLabel';
import {
  ControlButton,
  SecondaryButton,
} from '../../../../../components/Button';
import { SvgIcon } from '../../../../../components/Icon';
import Badge from '../../../../../components/Badge';

interface IProps {
  navigateToPrevious: () => void;
  navigateToNext: () => void;
  navigateToToday: () => void;
}

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
`;
const ControlButtonGroup = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
`;
const RightActionsWrapper = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  column-gap: 16px;
`;

export default memo(function Navigation({
  navigateToPrevious,
  navigateToNext,
  navigateToToday,
}: IProps) {
  const shortTimeZone = useSyndicateTimezoneLabel();

  return (
    <Container>
      <ControlButtonGroup>
        <ControlButton onClick={navigateToPrevious}>
          <SvgIcon
            name="caret-left"
            width={16}
            height={16}
            customFill="currentColor"
          />
        </ControlButton>
        <ControlButton onClick={navigateToNext}>
          <SvgIcon
            name="caret-right"
            width={16}
            height={16}
            customFill="currentColor"
          />
        </ControlButton>
      </ControlButtonGroup>
      <RightActionsWrapper>
        <Badge color="grey" size="primary">
          {shortTimeZone}
        </Badge>
        <SecondaryButton
          type="button"
          onClick={navigateToToday}
          isOutlined
          trackContext="calendar"
          trackAction="today"
        >
          Today
        </SecondaryButton>
      </RightActionsWrapper>
    </Container>
  );
});
